import { Box, Typography } from "@mui/material";
import { SPACING } from "../../../../../utils/constants/designConstants";

export const PFFFurtherReading = ({ furtherReading }) => {
  return (
    <Box sx={{ my: 4, display: "flex", gap: 1, flexDirection: "column" }}>
      <Typography variant="subtitle3" sx={{ mb: 2, color: "primary.brandMain" }}>
        Further Reading
      </Typography>
      <Box
        sx={{
          columnCount: { sm: 1, md: 2 },
          columnGap: 4,
        }}
      >
        {furtherReading.map((item, index) => (
          <Typography
            key={index}
            variant="body1"
            sx={{ color: "primary.white", mb: SPACING.ITEM_GAP, breakInside: "avoid" }}
          >
            {item}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
